import { Paper } from '@material-ui/core'
import ArchiveIcon from '@material-ui/icons/Archive'
import DescriptionIcon from '@material-ui/icons/Description'
import UnarchiveIcon from '@material-ui/icons/Unarchive'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
// import DescriptionIcon from '@material-ui/icons/Description'
import { EKOM_LINKS } from '../../EKOM_LINKS'
import { useCountIncoming } from '../../hooks/useCountIncoming'
import { useCountOutgoing } from '../../hooks/useCountOutgoing'
import { useCountSubmissions } from '../../hooks/useCountSubmissions'
import { useCountUnreadIncoming } from '../../hooks/useCountUnreadIncoming'
import { useCountUnreadOutgoing } from '../../hooks/useCountUnreadOutgoing'
import { useStyles } from './styles'

const EkomMenu = () => {
  const classes = useStyles()

  const incoming = useCountIncoming()
  const outgoing = useCountOutgoing()
  const submissions = useCountSubmissions()
  const unreadIncoming = useCountUnreadIncoming()
  const unreadOutgoing = useCountUnreadOutgoing()
  const countIncoming = incoming.data || 0
  const countOutgoing = outgoing.data || 0
  const countSubmissions = submissions.data || 0
  const countUnreadIncoming = unreadIncoming.data
  const countUnreadOutgoing = unreadOutgoing.data

  useEffect(() => {
    unreadOutgoing.fetchData()
    unreadIncoming.fetchData()
  }, [])
  return (
    <>
      {/*<Link to={LINKS.listSent}>*/}
      {/*  <Paper className={classes.paper}>*/}
      {/*    <Paper elevation={5} className={classes.box}>*/}
      {/*      <DescriptionIcon fontSize="large"/>*/}
      {/*    </Paper>*/}
      {/*    <div className={classes.dtext}>*/}
      {/*       Podanné nabídky*/}
      {/*    </div>*/}
      {/*    <div className={classes.bignum}>*/}
      {/*      11*/}
      {/*    </div>*/}
      {/*  </Paper>*/}
      {/*</Link>*/}
      <Link to={EKOM_LINKS.listRecv} className={classes.link}>
        <Paper elevation={5} className={classes.box}>
          <ArchiveIcon fontSize="large"/>
        </Paper>
        <div className={classes.dtext}>
          Přijaté zprávy
        </div>
        <div className={classes.bignum}>
          {countIncoming} {!!countUnreadIncoming && <span className={classes.bugNumUnread}>({countUnreadIncoming})</span>}
        </div>
      </Link>
      <Link to={EKOM_LINKS.listSent} className={classes.link}>
        <Paper elevation={5} className={classes.box}>
          <UnarchiveIcon fontSize="large"/>
        </Paper>
        <div className={classes.dtext}>
          Odeslané zprávy
        </div>
        <div className={classes.bignum}>
          {countOutgoing}  {!!countUnreadOutgoing && <span className={classes.bugNumUnread}>({countUnreadOutgoing})</span>}
        </div>
      </Link>

      <Link to={EKOM_LINKS.listSubmissions} className={classes.link}>
        <Paper elevation={5} className={classes.box}>
          <DescriptionIcon fontSize="large"/>
        </Paper>
        <div className={classes.dtext}>
          Podání
        </div>
        <div className={classes.bignum}>
          {countSubmissions}
        </div>
      </Link>
    </>
  )
}

export default EkomMenu
